export function LegalFooter() {
  return (
    <footer className="legal-footer">
      <div className="lf-inner">
        <div className="lf-top">
          <div className="lf-brand">
            <div className="lf-brand-name">TeleGraphyx</div>
            <p className="lf-brand-text">
              Платформа для продвижения и аналитики MAX-каналов.
            </p>
          </div>
          <div className="lf-docs">
            <h4 className="lf-docs-h">Документы</h4>
            <ul>
              <li><a href="https://telegraphyx.ru/public-offer/" target="_blank" rel="noopener noreferrer">Публичная оферта</a></li>
              <li><a href="https://telegraphyx.ru/privacy-policy/" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a></li>
              <li><a href="https://telegraphyx.ru/personalsoglasio/" target="_blank" rel="noopener noreferrer">Обработка персональных данных</a></li>
              <li><a href="https://telegraphyx.ru/reklamasoglasio/" target="_blank" rel="noopener noreferrer">Согласие на рассылки</a></li>
            </ul>
          </div>
        </div>
        <div className="lf-bottom">
          <span>© 2024 TeleGraphyx. Все права защищены.</span>
          <span>ИП Матвеева А.Ю., ИНН 510107251374</span>
        </div>
      </div>

      <style>{`
        .legal-footer {
          background: var(--tg-paper, #fafafd);
          color: var(--tg-mute, #8f9eb0);
          padding: 32px 0 24px;
          margin-top: 80px;
          margin-bottom: -32px; /* съедаем нижний padding родителя .onb-main */
          font-family: var(--tg-font-ui, Inter, sans-serif);
          border-top: 1px solid var(--tg-line-2, rgba(143,158,176,0.24));
          /* full-bleed: вырываемся из родительского контейнера на всю ширину viewport'а */
          width: 100vw;
          position: relative;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;
        }
        .lf-inner {
          max-width: 960px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .lf-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 32px;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }
        .lf-brand-name {
          color: var(--tg-ink-2, #3c424c);
          font-size: 15px;
          font-weight: 700;
          letter-spacing: -0.01em;
        }
        .lf-brand-text {
          color: var(--tg-mute, #8f9eb0);
          font-size: 12px;
          margin: 6px 0 0;
          max-width: 280px;
          line-height: 1.5;
        }
        .lf-docs-h {
          margin: 0 0 10px;
          color: var(--tg-mute, #8f9eb0);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .lf-docs ul {
          margin: 0;
          padding: 0;
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .lf-docs a {
          color: var(--tg-mute, #8f9eb0);
          text-decoration: none;
          font-size: 12px;
          transition: color 120ms;
        }
        .lf-docs a:hover { color: var(--tg-blue, #0080ff); }
        .lf-bottom {
          border-top: 1px solid var(--tg-line-2, rgba(143,158,176,0.18));
          padding-top: 14px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 8px;
          font-size: 11px;
          color: var(--tg-mute-2, #b4c0d0);
        }
        @media (max-width: 600px) {
          .legal-footer { padding: 32px 0; }
          .lf-top { flex-direction: column; gap: 24px; margin-bottom: 20px; }
          .lf-bottom { flex-direction: column; gap: 6px; }
        }
      `}</style>
    </footer>
  )
}
